import { api } from "@/lib/api";
import { hasConsent } from "@/lib/consent";

function uid() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
}

export function getVisitorId() {
  try {
    let v = localStorage.getItem("vs_vid");
    if (!v) { v = uid(); localStorage.setItem("vs_vid", v); }
    return v;
  } catch { return "anon"; }
}

function getSessionId() {
  try {
    let s = sessionStorage.getItem("vs_sid");
    if (!s) { s = uid(); sessionStorage.setItem("vs_sid", s); }
    return s;
  } catch { return ""; }
}

function detectDevice() {
  const ua = navigator.userAgent || "";
  if (/iPad|Tablet|PlayBook|Silk|(Android(?!.*Mobile))/i.test(ua)) return "tablet";
  if (/Mobi|Android|iPhone|iPod|Windows Phone/i.test(ua)) return "mobile";
  return "desktop";
}

function send(payload) {
  // First-party analytics: only collected after the visitor grants "analytics" consent.
  if (!hasConsent("analytics")) return;
  const body = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    device: detectDevice(),
    referrer: document.referrer || "",
    ...payload,
  };
  // fire-and-forget; never block UI
  api.post("/track", body).catch(() => {});
}

export function trackPageview(path, title) {
  send({ type: "pageview", path: path || window.location.pathname, title: title || document.title });
}

export function trackCta(label) {
  send({ type: "cta", path: window.location.pathname, label });
}

export function trackDownload(label) {
  send({ type: "download", path: window.location.pathname, label });
}
